import errorManager from '@/rollbar.js';

const csvUpdateOnChange = () => {
  document.addEventListener('change', (ev) => {
    const target = ev.target;

    if (target.id === 'hide-not-in-use') {
      const isChecked = target.checked;
      const decodesCsvLink = document.getElementById('decodes-csv-link');
      const currentHref = decodesCsvLink.getAttribute('href');

      const newHref = isChecked ? addQueryParam(currentHref, 'hide_not_in_use', 'true') : removeQueryParam(currentHref, 'hide_not_in_use');

      decodesCsvLink.setAttribute('href', newHref);
    }
  });
};

const addQueryParam = (url, key, value) => {
  const [baseUrl, queryString] = url.split('?');
  const params = new URLSearchParams(queryString || '');
  params.set(key, value);
  return `${baseUrl}?${params.toString()}`;
};

const removeQueryParam = (url, key) => {
  const [baseUrl, queryString] = url.split('?');
  const params = new URLSearchParams(queryString || '');
  params.delete(key);
  const newQueryString = params.toString();
  return newQueryString ? `${baseUrl}?${newQueryString}` : baseUrl;
};

const init = () => {
  try {
    csvUpdateOnChange();
  } catch (e) {
    errorManager(e);
  }
};

window.DecodesModal = {
  init: init,
};
